/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Retake_Note_SideInputs */

const en_us2_body_assessment_retake_note_side = /** @type {(inputs: Body_Assessment_Retake_Note_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only the side photo needs retaking. The front one still counts.`)
};

const pt_br2_body_assessment_retake_note_side = /** @type {(inputs: Body_Assessment_Retake_Note_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só a foto de lado precisa ser refeita. A de frente continua valendo.`)
};

const es_419_body_assessment_retake_note_side = /** @type {(inputs: Body_Assessment_Retake_Note_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo hay que volver a tomar la foto de lado. La de frente sigue valiendo.`)
};

const pt_pt2_body_assessment_retake_note_side = /** @type {(inputs: Body_Assessment_Retake_Note_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só a foto de lado precisa de ser repetida. A de frente continua a valer.`)
};

const fr_fr2_body_assessment_retake_note_side = /** @type {(inputs: Body_Assessment_Retake_Note_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seule la photo de profil est à reprendre. Celle de face reste valable.`)
};

const de_de2_body_assessment_retake_note_side = /** @type {(inputs: Body_Assessment_Retake_Note_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur das Seitenfoto muss neu. Das Frontfoto zählt weiter.`)
};

const it_it2_body_assessment_retake_note_side = /** @type {(inputs: Body_Assessment_Retake_Note_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Va rifatta solo la foto laterale. Quella frontale resta valida.`)
};

/**
* | output |
* | --- |
* | "Only the side photo needs retaking. The front one still counts." |
*
* @param {Body_Assessment_Retake_Note_SideInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_retake_note_side = /** @type {((inputs?: Body_Assessment_Retake_Note_SideInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Retake_Note_SideInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_retake_note_side(inputs)
	if (locale === "es-419") return es_419_body_assessment_retake_note_side(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_retake_note_side(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_retake_note_side(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_retake_note_side(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_retake_note_side(inputs)
	return en_us2_body_assessment_retake_note_side(inputs)
});
export { body_assessment_retake_note_side as "body-assessment.retake_note_side" }